import {ChangeDetectionStrategy, Component, inject, input} from '@angular/core';
import {MatCardModule} from '@angular/material/card';
import {EmbeddingAugmentorResultDTO} from '../../dto/embedding';
import {Store} from '@ngrx/store';
import {selectPapersByProjectIdAndPaperId} from '../../../research/services/research-paper/research-paper.selectors';
import {combineLatest} from 'rxjs';
import {ResearchPaperDTO} from '../../../research/dto/research-paper';
import {
  ResearchPaperDialogComponent
} from '../../../research/components/research-paper-dialog/research-paper-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {toObservable, toSignal} from '@angular/core/rxjs-interop';
import {switchMap} from 'rxjs/operators';

@Component({
  selector: 'app-paper-embedding-paper-card',
  imports: [MatCardModule],
  templateUrl: './paper-embedding-paper-card.component.html',
  styleUrl: './paper-embedding-paper-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaperEmbeddingPaperCardComponent {
  private readonly store: Store = inject(Store);
  private readonly dialog: MatDialog = inject(MatDialog);

  readonly embeddingResult = input.required<EmbeddingAugmentorResultDTO>();
  readonly projectId = input.required<number>();
  readonly isSmallScreen = input<boolean>(false);

  readonly paper = toSignal(
    combineLatest([toObservable(this.projectId), toObservable(this.embeddingResult)]).pipe(
      switchMap(([projectId, embeddingResult]) =>
        this.store.select(selectPapersByProjectIdAndPaperId(projectId, embeddingResult.paperId))
      )
    ),
    {initialValue: undefined as ResearchPaperDTO | undefined}
  );

  viewDetails(paper: ResearchPaperDTO): void {
    this.dialog.open(ResearchPaperDialogComponent, {
      data: {
        isMobile: this.isSmallScreen(),
        paper: paper
      },
      autoFocus: false,
      width: this.isSmallScreen() ? '100vw' : '90%',
      height: this.isSmallScreen() ? '100vh' : '90%',
      maxWidth: '100vw',
    });

  }
}
